import script from "./Displays.vue?vue&type=script&setup=true&lang=js"
export * from "./Displays.vue?vue&type=script&setup=true&lang=js"

import "./Displays.vue?vue&type=style&index=0&id=ae9aa504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae9aa504"]])

export default __exports__